module.exports = __webpack_public_path__ + "static/media/amritsarwebp.20704e35.webp";